<template>
  <div class="flex flex-wrap items-center gap-2">
    <Tag
      v-for="tag in tags"
      :class="
        tag.id !== 'add_tags'
          ? 'hover:cursor-default'
          : canUpdate && !disabled
          ? 'hover:cursor-pointer'
          : 'hover:cursor-not-allowed'
      "
      :key="tag.id"
      :tag="tag"
      @click="handleClick(tag.id)"
    />
  </div>
</template>

<script setup>
import { Tag } from "@/Components/Tags";

const emit = defineEmits(["addTags", "click"]);

defineProps({
  tags: { type: Array, default: () => [] },
  canUpdate: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});

function handleClick(tagId) {
  if (tagId === "add_tags") {
    emit("addTags");
    return;
  }
  emit("click", tagId);
}
</script>
